import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { URL_LIST_ALL } from '../configs/api';
import tim from '../assets/img/action/tim.png'
import tim_bl from '../assets/img/action/tim-bl.png'
import wow from '../assets/img/action/wow.png'
import wow_bl from '../assets/img/action/wow-bl.png'

const reactionOptions = [
    { type: 'like', label: '👍 Thích' },
    { type: 'love', label: '❤️ Tim' },
    { type: 'wow', label: '😲 Wow' },
];

const PostAction = ({ post, userReact = null,onShowPost,countComment }) => {
    const { user } = useSelector((state) => state.auth);
    const { saveLike } = useSelector((state) => state.save);
    const [likes, setLikes] = useState(post && post.list_like ? post.list_like : [] );
    const [myReact, setMyReact] = useState(userReact); // null | 'like' | 'love' | 'angry'

    useEffect(() => {
        const found = post.list_like.find(like => like.user_id == user.data.id);
        setMyReact(found ? found.type : null);
    }, [post && post.list_like, user.data.id]);

    // Khi nhận socket về hành động cảm xúc mới
    useEffect(() => {
        if (saveLike?.post_id == post.id) {
            setLikes(prev => {
                const filtered = prev.filter(like => like.user_id != saveLike.user_id);
                return [...filtered, saveLike];
            });
            if (saveLike.user_id == user.data.id) {
                setMyReact(saveLike.type);
            }
        }        
    }, [saveLike, post && post.id]);

    const handleReact = async (type) => {
        setLikes(prev => {
            const filtered = prev.filter(like => like.user_id != user.data.id);
            return [...filtered, {
                user_id: user.data.id,
                fullname: user.data.fullname,
                type,
                post_id: post.id,
                status: 1
            }];
        });
        setMyReact(type);
        try {
            Axios.post(URL_LIST_ALL + 'posts_like', { user_id: user.data.id, type: type, status: 1, post_id: post.id }, user.config).then(res => {
                if (res.data.status == "success") {

                } else {
                    alert(res.data.message)
                }
            }).catch(err => {
                console.log(err)
            });

        } catch (err) {
            console.error('Lỗi gửi bình luận:', err);
        }
    };
    const check_type = (type) => {
        if (type === 'like') return <i className='fas fa-thumbs-up'></i>
        if (type === 'love') return <img src={tim} className='ico ico-active' />
        if (type === 'wow') return <img src={wow} className='ico ico-active' />
    }

   
    return (
        <>
            <div className="reaction-summary">
                <div className="reaction-icons d-flex">
                    {reactionOptions.map(opt => {
                        const hasUsers = likes.some(like => like.type === opt.type);
                        return hasUsers ? (
                            <div className='show-action' key={opt.type}>
                                {check_type(opt.type)}
                            </div>
                        ) : null;
                    })}
                </div>

                <div className="reaction-users">
                    {post && likes && likes.length > 0 && (() => {
                        // Lấy unique user theo user_id để tránh trùng
                        // console.log(likes);
                        const uniqueLikesMap = new Map();
                        likes.forEach(item => {
                            uniqueLikesMap.set(item.user_id, item.fullname);
                        });

                        const allUsers = Array.from(uniqueLikesMap.entries()).map(([id, name]) => ({
                            user_id: id,
                            fullname: name
                        }));

                        // Kiểm tra xem user hiện tại đã thả chưa
                        const youLiked = allUsers.find(u => u.user_id == user.data.id);
                        const others = allUsers.filter(u => u.user_id != user.data.id);

                        // Sắp xếp lại: 'Bạn' + 2 người tiếp theo
                        const displayUsers = [];
                        if (youLiked) displayUsers.push("Bạn");
                        displayUsers.push(...others.slice(0, 2).map(u => u.fullname));

                        const more = others.length - 2;
                        return (
                            <>
                                {displayUsers.join(', ')}
                                {more > 0 && ` và ${more} người khác`}
                            </>
                        );
                    })()}
                </div>
                <div className="list-user-action border shaddow-sm">
                    {likes.map((like, index) => (
                        <div className='show-action mb-2' key={index}>
                            {check_type(like.type)} {like.fullname}
                        </div>
                    ))}
                </div>
            </div>

            <div className="reaction-bar border-top">
                {reactionOptions.map((opt, i) => (
                    <button
                        key={i}
                        type='button'
                        className={`reaction-btn btn-action-${opt.type} ${myReact == opt.type ? 'active' : ''}`}
                        onClick={() => handleReact(opt.type)}
                    >
                        {opt.type == 'like' && <><i className='fas fa-thumbs-up ico ico-active'></i><i className='far fa-thumbs-up ico'></i> Like</>}
                        {opt.type == 'love' && <><img src={tim} className='ico ico-active' /> <img src={tim_bl} className='ico' /> Tim</>}
                        {opt.type == 'wow' && <><img src={wow} className='ico ico-active' /> <img src={wow_bl} className='ico' /> Wow</>}
                    </button>
                ))}
                <div className='sticker-group'>
                    <button type='button' className='reaction-btn btn-action-comment' onClick={() => { onShowPost && onShowPost()}}>
                        <i className='far fa-comment-dots ico'></i><i className='fas fa-comment-dots ico ico-active'></i> Comment
                        {countComment && countComment > 0 ? <span className='counter'>{post.getComment ? post.getComment.length : 0}</span> : ''}
                    </button>
                </div>
            </div>
        </>
    );
};

export default PostAction;
